import { createContext, useContext } from 'react';
import { type OptimizelyDecision } from '@optimizely/react-sdk';

export const initialStateDecision: OptimizelyDecision = {
  variationKey: null,
  userContext: {
    id: null,
    attributes: undefined,
  },
  enabled: false,
  variables: {},
  ruleKey: null,
  flagKey: '',
  reasons: [],
};

export const variableGrowthUpgrade = {
  ...initialStateDecision,
  variables: {
    heading: '',
    subheading: '',
    overMillionSection: {
      perkList: [],
    },
    perks: {
      list: [],
    },
    plans: {
      seasonal: {
        heading: '',
        subheading: '',
      },
      annual: {
        heading: '',
        subheading: '',
      },
    },
  },
};

export type GrowthUpgradeType = typeof variableGrowthUpgrade;

export interface UpgradeContextType {
  growthUpgrade: GrowthUpgradeType;
}

const defaultUpgradeContext: UpgradeContextType = {
  growthUpgrade: variableGrowthUpgrade,
};

export const UpgradeMembershipContext = createContext(defaultUpgradeContext);

export function useUpgradeMembershipContext() {
  const context = useContext(UpgradeMembershipContext);
  if (!context) {
    throw new Error('You must use the UpgradeMembershipProvider in order to consume this context.');
  }
  return context;
}
